import validate from "/app/node_modules/.pnpm/nuxt@4.5.2_b39e155b9d5ab875bcce11a20b66e7bf/node_modules/nuxt/dist/pages/runtime/validate.js";
import advisor_45guard_45global from "/app/apps/ui/middleware/advisor-guard.global.ts";
import delisted_45route_45redirects_45global from "/app/apps/ui/middleware/delisted-route-redirects.global.ts";
import legacy_45route_45redirects_45global from "/app/apps/ui/middleware/legacy-route-redirects.global.ts";
import onboarding_45guard_45global from "/app/apps/ui/middleware/onboarding-guard.global.ts";
import project_45access_45global from "/app/apps/ui/middleware/project-access.global.ts";
import project_45id_45global from "/app/apps/ui/middleware/project-id.global.ts";
import project_45realtime_45global from "/app/apps/ui/middleware/project-realtime.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.5.2_b39e155b9d5ab875bcce11a20b66e7bf/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  advisor_45guard_45global,
  delisted_45route_45redirects_45global,
  legacy_45route_45redirects_45global,
  onboarding_45guard_45global,
  project_45access_45global,
  project_45id_45global,
  project_45realtime_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/middleware/auth.ts"),
  guest: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/middleware/guest.ts"),
  "ai-chat-enabled": () => import("/app/apps/ui/layers/ai-chat/middleware/ai-chat-enabled.ts"),
  "check-market-maker-dashboard": () => import("/app/apps/ui/layers/free-tools/monitor-market-makers/middleware/checkMarketMakerDashboard.ts"),
  "mmm-v2-pre-activation": () => import("/app/apps/ui/layers/free-tools/monitor-market-makers/middleware/mmmV2PreActivation.ts"),
  "design-tokenomics-scope": () => import("/app/apps/ui/layers/free-tools/design-tokenomics/middleware/designTokenomicsScope.ts"),
  "uer-enabled": () => import("/app/apps/ui/layers/public-research/middleware/uer-enabled.ts"),
  "rfq-compare-guard": () => import("/app/apps/ui/middleware/rfq-compare-guard.ts")
}